const InitialState = {
  instructorCoursesMap: null,
  instructorImportCoursesList: [],
  studentCoursesMap: [],
  publicCoursesMap: [],
  instituteList: [],
  departmentList: [],
  paginationInfo: null,

  studentCourseGroupsMap: {},
  studentGroupConceptsMap: {},
  instructorCourseGC: {
    instructorCourseGroupsMap: {},
    instructorGroupConceptsMap: {},
  },
  otherLabs: [],
  labs: {
    access_control_vars: {},
    labs: [],
    allLabs: [],
    totalCount: 0,
    stats: { all: 0, visible: 0, hidden: 0, exams: 0 },
    accessControlVars: {},
  },
  instructorConceptDataMap: {},
  studentConceptDataMap: {},
  userInfo: {
    loading: false,
    username: null,
    email: null,
    token: null,
    expirationDate: null,
    error: null,
    msg: null,
    mode: null,
  },
  userCourseRole: null,
  forum: {},
  scheduleList: [],
  studentprogramming: new Map(),
  instructorProgramming: new Map(),
  issues: new Map(),
  studentGrades: {
    loading: false,
    tableData: [],
  },
  fileUploadProgress: {
    uploadProgress: '',
    uploadRequestStatus: '',
  },
  analytics: {
    sessionId: null,
    fingerprint: null,
    currentHitId: null,
    lastHitId: null,
    pageStartTime: null,
    campaignId: null,
    utmData: {
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_term: null,
      utm_content: null,
    },
    isTracking: false,
    isInitializing: false,
    isUpdatingTime: false,
    initialized: false,
    sessionStartTime: null,
    totalPageHits: 0,
    totalTimeTracked: 0,
    lastTrackingTime: null,
    error: null,
    lastError: null,
    errorCount: 0,
    config: {
      enableTracking: true,
      enableErrorTracking: true,
      enablePerformanceTracking: true,
      debounceTime: 1000,
    },
  },
  chatbot:{
    messages: [],     
    externalData: null,
  }
};
export default InitialState;
